<span class="chip">
  {{ "SHARED.BUILDING_TYPES." + buildingType | translate }}
</span>
